/* furbos-cleanse3.js: assets/furbos-cleanse2.js for templates/product.cleanse3.json (2026-10-15).
   The old pack rows ([data-c2-offer]) are not on this template, so every buy-box function below
   finds no root and does nothing; the offer box is snippets/cleanse3-offer.liquid with
   assets/cleanse3-offer.js. Kept here: gallery, tabs, accordions, formula modal, questions,
   ship date, and the buttons (sticky bar, Try it risk free) that now scroll to the offer box. */
/* ============================================================================
   furbos-cleanse2.js
   Script of templates/product.cleanse2.json (Furbos Parasite Cleanse Drops).
   Loaded by snippets/cleanse2-assets.liquid and by no other template.
   Source: pdp4/build/src/furbos-cleanse2.js.

   1. THE BUY BOX
      Three bundle rows (one variant each, quantity always 1) and, under them, the
      refill checkbox box. This file paints the rows and writes the theme's own
      product form. It never adds to the cart itself: the theme's buy buttons
      block keeps the form, the button and the trip to checkout (skip_cart).

      What is posted on Add To Cart:
        id                           the variant of the selected row
        selling_plan                 only while the box is ticked AND that variant
                                     carries a plan
        properties[Bottles Included] bottles in the pack (1, 3 or 5)
        properties[_ship_units]      the same number, for fulfilment
      There is no quantity field: every row is quantity 1.

      NO PRICE, NO PLAN ID AND NO SAVING IS TYPED IN THIS FILE. Everything comes
      from the variant JSON printed by snippets/cleanse2-buybox-top.liquid:
      price, compare_at_price and selling_plan_allocations, in the buyer's own
      currency.

      STATES
        variant has no plan    box hidden, rows at the variant price
        plan, box ticked       rows at the plan price, selling_plan posted
                               (this is how the page loads)
        plan, box unticked     rows at the variant price, no selling_plan
      Unticking the box is how a visitor buys once. There is no other control.

      THE REFILL LABEL. "Save [refill_saved] with Automatic Refills" is filled
      for the selected row from that variant's own plan: (variant price - plan
      price) / variant price, a whole percent. Liquid prints the same figure for
      first paint.

      ONE PACK IN THE CART. If the cart already holds a pack of this product, it
      is removed before the new one is added, so checkout holds the one pack just
      chosen. Every failure path ends in the theme's own add.

      KEEP OUT. assets/furbos-offer.js runs on every page and takes over
      quantity-breaks, shrine-subscription-widget, .furbos-price-update and
      data-furbos-* nodes. This file and its markup use c2- names only.

   2. PAGE BEHAVIOUR
      The gallery (thumbnails and the slide on screen), tabs, the six accordions
      (one open at a time), the Full formula modal, the question tabs with their
      show more button, and the buttons that scroll to the pack rows or to the
      reviews.

   ES5 on purpose. Every paint is wrapped so a display error never stops a sale.
   ============================================================================ */
(function () {
  'use strict';

  if (window.furbosCleanse3) return;

  /* wantsSub is the buyer's intent. It survives moving between rows. */
  var state = { wantsSub: true };
  var warned = {};
  var cache = { list: null };

  var ADD_SEL = '[name="add"], .product-form__submit, .main-product-atc, .sticky-atc__add_button';

  /* ---- money ---------------------------------------------------------------- */

  function group(v, dec) {
    var parts = v.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function money(cents, format) {
    var n = Math.round(cents) / 100;
    var noTrailing = Math.round(cents) % 100 === 0;
    return String(format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, noTrailing ? group(n, 0) : group(n, 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(n, 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,
        group(n, 2).replace(/,/g, '\u0001').replace('.', ',').replace(/\u0001/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        group(n, 0).replace(/,/g, '.'))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,
        group(n, 2).replace(/,/g, "'"));
  }

  /* ---- finding things ------------------------------------------------------- */

  function rootEl() {
    return document.querySelector('[data-c2-offer]');
  }

  function scopeOf(el) {
    return (el && el.closest && el.closest('.shopify-section')) || document;
  }

  function formOf(root) {
    return scopeOf(root).querySelector('form[data-type="add-to-cart-form"]');
  }

  function byId(list, id) {
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return list[i];
    }
    return null;
  }

  function bottlesOf(label) {
    return parseInt(label.getAttribute('data-bottles'), 10) || 1;
  }

  /* The variant JSON, read once. */
  function variantsOf(root) {
    if (cache.list && cache.root === root) return cache.list;
    var tag = root.querySelector('script[data-c2-variants]');
    if (!tag) return null;
    var list = null;
    try { list = JSON.parse(tag.textContent); } catch (e) { return null; }
    if (!list || !list.length) return null;
    cache.list = list;
    cache.root = root;
    return list;
  }

  function checkedRadio(root) {
    var radios = root.querySelectorAll('input[name="c2-tier"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return radios[i];
    }
    for (var j = 0; j < radios.length; j++) {
      if (!radios[j].disabled) { radios[j].checked = true; return radios[j]; }
    }
    return null;
  }

  /* ---- selling plan --------------------------------------------------------- */

  function planPrice(alloc, variant) {
    if (alloc.per_delivery_price != null) return alloc.per_delivery_price;
    if (alloc.price != null) return alloc.price;
    return variant.price;
  }

  /* Only ever the variant's own allocations, so a plan the variant does not
     carry can never be posted and turn a refill into a failed add to cart. */
  function planOf(variant) {
    var list = variant && variant.selling_plan_allocations;
    if (!list || !list.length) return null;
    var best = list[0];
    for (var i = 1; i < list.length; i++) {
      if (planPrice(list[i], variant) < planPrice(best, variant)) best = list[i];
    }
    if (list.length > 1 && !warned[variant.id] && window.console && console.warn) {
      warned[variant.id] = true;
      console.warn('[cleanse2] variant ' + variant.id + ' carries ' + list.length +
        ' selling plans. Using the cheapest (' + best.selling_plan_id +
        '). Attach one Seal rule per variant.');
    }
    return best;
  }

  /* ---- paint ---------------------------------------------------------------- */

  function fill(node, tokens) {
    var tpl = node.getAttribute('data-text');
    if (tpl == null) return;
    var out = tpl;
    for (var k in tokens) {
      if (Object.prototype.hasOwnProperty.call(tokens, k)) {
        out = out.split('[' + k + ']').join(tokens[k]);
      }
    }
    if (node.textContent !== out) node.textContent = out;
  }

  function setText(node, text) {
    if (node && text != null && node.textContent !== text) node.textContent = text;
  }

  function attr(node, name, fallback) {
    var v = node.getAttribute(name);
    return (v == null || v === '') ? fallback : v;
  }

  function paintSubBox(root, sel) {
    var wrap = scopeOf(root).querySelector('[data-c2-sub]');
    if (!wrap) return;
    var hasPlan = !!sel.plan;
    if (wrap.hidden !== !hasPlan) wrap.hidden = !hasPlan;
    var box = wrap.querySelector('[role="checkbox"]');
    if (!box) return;
    var on = sel.subOn ? 'true' : 'false';
    if (box.getAttribute('aria-checked') !== on) box.setAttribute('aria-checked', on);

    /* The saving on the label belongs to the selected row and is read from its
       plan. With no saving to name, the label names the refill only. */
    var label = wrap.querySelector('[data-c2-refill-label]');
    if (label && hasPlan) {
      setText(label, sel.refillPct > 0
        ? attr(label, 'data-text', 'Save [refill_saved] with Automatic Refills')
            .split('[refill_saved]').join(sel.refillPct + '%')
        : attr(label, 'data-text-plain', 'Automatic Refills'));
    }
  }

  function packNames(list) {
    var names = [];
    for (var i = 0; i < list.length; i++) names.push(list[i].bottles + ' bottle');
    if (names.length < 2) return names.join('');
    return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
  }

  /* The sentence that says which packs ship free (guarantee accordion and the
     shipping cost answer), in the state the buyer is in: refill or buy once.
     Same prices as the rows, the free shipping line of
     snippets/cleanse2-shipmin.liquid, and the wording printed on the rows'
     wrapper. snippets/cleanse2-shipnote.liquid prints the same sentence for
     first paint. */
  function paintShipNote(root, sel) {
    var nodes = document.querySelectorAll('[data-c2-shipnote]');
    if (!nodes.length || !sel.packs || !sel.packs.length) return;
    var min = parseInt(root.getAttribute('data-free-ship-min') || '0', 10) || 0;
    var text;
    if (!min) {
      text = attr(root, 'data-shipnote-unknown', 'Shipping is calculated at checkout.');
    } else {
      var free = [], fee = [];
      for (var p = 0; p < sel.packs.length; p++) {
        (sel.packs[p].price >= min ? free : fee).push(sel.packs[p]);
      }
      if (!fee.length) {
        text = attr(root, 'data-shipnote-all', 'Every pack ships free.');
      } else if (!free.length) {
        text = attr(root, 'data-shipnote-none', 'Standard shipping is added at checkout.');
      } else {
        var a = (free.length > 1
          ? attr(root, 'data-shipnote-free-many', 'The [packs] packs ship free.')
          : attr(root, 'data-shipnote-free-one', 'The [packs] pack ships free.'))
          .split('[packs]').join(packNames(free));
        var b = (fee.length === 1 && fee[0].bottles === 1)
          ? attr(root, 'data-shipnote-fee-single', 'A single bottle pays standard shipping at checkout.')
          : (fee.length > 1
              ? attr(root, 'data-shipnote-fee-many', 'The [packs] packs pay standard shipping at checkout.')
              : attr(root, 'data-shipnote-fee-one', 'The [packs] pack pays standard shipping at checkout.'))
            .split('[packs]').join(packNames(fee));
        text = a + ' ' + b;
      }
    }
    for (var j = 0; j < nodes.length; j++) setText(nodes[j], text);
  }

  /* ---- the form: this is what actually gets charged -------------------------- */

  function fieldsNamed(form, name) {
    var out = [];
    var all = form.querySelectorAll('input, select');
    for (var i = 0; i < all.length; i++) {
      if (all[i].name === name) out.push(all[i]);
    }
    return out;
  }

  function setField(form, name, value) {
    var found = fieldsNamed(form, name);
    var want = (value == null) ? '' : String(value);
    if (!want) {
      /* Remove what this page added; blank anything it did not add. */
      for (var i = 0; i < found.length; i++) {
        if (found[i].hasAttribute('data-c2-field')) {
          found[i].parentNode.removeChild(found[i]);
        } else if (found[i].value !== '') {
          found[i].value = '';
        }
      }
      return;
    }
    if (!found.length) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-c2-field', '');
      input.value = want;
      form.appendChild(input);
      return;
    }
    for (var j = 0; j < found.length; j++) {
      if (String(found[j].value) !== want) found[j].value = want;
    }
  }

  function syncForm(root, sel) {
    var form = formOf(root);
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && String(idInput.value) !== String(sel.id)) idInput.value = String(sel.id);
    var plan = (sel.subOn && sel.plan) ? sel.plan.selling_plan_id : '';
    setField(form, 'selling_plan', plan);
    setField(form, 'properties[Bottles Included]', sel.bottles);
    setField(form, 'properties[_ship_units]', sel.bottles);
  }

  /* ---- one pass over everything ---------------------------------------------- */

  /* Works out the selected line from the DOM and the variant JSON. Returns null
     only when there is no row at all. */
  function selection(root, paint) {
    var list = variantsOf(root);
    var radio = checkedRadio(root);
    if (!radio) return null;

    var format = String(root.getAttribute('data-money-format') || '${{amount}}')
      .replace(/\s*[A-Z]{3}\s*$/, '');   /* never print the ISO code */
    var labels = root.querySelectorAll('label.c2-row');
    var sel = null;
    var packs = [];

    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var id = label.getAttribute('data-variant-id');
      var bottles = bottlesOf(label);
      var variant = byId(list, id);
      var isSelected = String(radio.value) === String(id);

      if (!variant) {
        /* JSON missing: leave the Liquid paint alone, still post what is shown. */
        if (isSelected) sel = { id: id, bottles: bottles, plan: null, subOn: false, price: null, format: format };
        continue;
      }

      var plan = planOf(variant);
      var subOn = state.wantsSub && !!plan;
      var price = subOn ? planPrice(plan, variant) : variant.price;
      /* What the refill takes off this row's own one-time price. */
      var refillPrice = plan ? planPrice(plan, variant) : null;
      var refillPct = (plan && variant.price > refillPrice)
        ? Math.round(((variant.price - refillPrice) * 100) / variant.price) : 0;
      var compare = variant.compare_at_price || 0;
      /* Rounded, not floored: 52.86 reads 53, as the two prices on the row say. */
      var pct = compare > price ? Math.round(((compare - price) * 100) / compare) : 0;
      packs.push({ bottles: bottles, price: price });

      if (paint) {
        var tokens = {
          price: money(price, format),
          compare_price: money(compare, format),
          percentage_saved: pct + '%'
        };
        var nodes = label.querySelectorAll('.c2-price-update[data-text]');
        for (var j = 0; j < nodes.length; j++) fill(nodes[j], tokens);
        var cmp = label.querySelector('[data-c2-compare]');
        if (cmp) cmp.classList.toggle('c2-off', compare <= price);
        var saving = label.querySelector('[data-c2-saving]');
        if (saving) saving.classList.toggle('c2-off', pct <= 0);
      }

      if (isSelected) {
        sel = { id: id, bottles: bottles, plan: plan, subOn: subOn, price: price, format: format,
                compare: compare, pct: pct, refillPct: refillPct };
      }
    }
    if (sel) sel.packs = packs;
    return sel;
  }

  function safely(fn) {
    try { fn(); } catch (e) { /* never break the page over a price */ }
  }

  function render() {
    var root = rootEl();
    if (!root) return;
    var sel = null;
    safely(function () { sel = selection(root, true); });
    if (!sel) return;
    safely(function () { syncForm(root, sel); });
    if (sel.price == null) return;
    safely(function () { paintSubBox(root, sel); });
    safely(function () { paintShipNote(root, sel); });
  }

  /* The theme bundle repaints parts of the section on its own schedule, so
     repaint after it on a short tail rather than fighting it with an observer. */
  function schedule() {
    render();
    [0, 80, 300, 900].forEach(function (t) { setTimeout(render, t); });
  }

  /* ---- wiring ---------------------------------------------------------------- */

  function toggleSub() {
    state.wantsSub = !state.wantsSub;
    schedule();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'c2-tier') schedule();
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-c2-sub] [role="checkbox"]')) { toggleSub(); return; }
    if (t.closest('[data-c2-offer]')) schedule();
  }, false);

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (e.key !== ' ' && e.key !== 'Enter' && e.key !== 'Spacebar') return;
    if (!t.matches('[data-c2-sub] [role="checkbox"]')) return;
    e.preventDefault();
    toggleSub();
  }, false);

  /* Capture phase: runs before the theme's own add to cart handler, so the line
     is posted with the right variant and plan even when the theme adds over
     fetch and never fires a submit event. */
  function forceSync(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest(ADD_SEL + ', form[action*="/cart/add"]')) return;
    var root = rootEl();
    if (!root) return;
    safely(function () {
      var sel = selection(root, false);
      if (sel) syncForm(root, sel);
    });
  }
  document.addEventListener('click', forceSync, true);
  document.addEventListener('submit', forceSync, true);

  /* ---- one pack in the cart ---------------------------------------------------
     The cart is read when the page shows (a fresh load, or a return from checkout
     through the back button). Lines of this product already in it are remembered
     by key. Only then does a press on Add To Cart wait: the old lines are set to
     zero, and the same button is pressed again so the theme's own add runs exactly
     as it always does. Every failure path ends in that same press, so this can
     delay a sale by a moment but never block one. */

  var cart = { stale: [] };
  var passing = false;
  var pending = false;

  function cartRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (typeof r === 'string' && r) ? r : '/';
  }

  function readCart() {
    var root = rootEl();
    if (!root || !window.fetch) return;
    /* Every variant of this product counts, also the packs sold on the store's
       other pages: checkout must hold the one pack just chosen. */
    var mine = {};
    var all = variantsOf(root) || [];
    for (var a = 0; a < all.length; a++) mine[String(all[a].id)] = true;
    var labels = root.querySelectorAll('label.c2-row');
    for (var i = 0; i < labels.length; i++) mine[String(labels[i].getAttribute('data-variant-id'))] = true;
    try {
      window.fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var keys = [];
          var items = (data && data.items) || [];
          for (var j = 0; j < items.length; j++) {
            if (mine[String(items[j].variant_id)] && items[j].key) keys.push(items[j].key);
          }
          cart.stale = keys;
        })
        .catch(function () { /* unknown cart: add as the theme always has */ });
    } catch (e) { /* same */ }
  }

  function onePack(e) {
    if (passing) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[name="add"], .product-form__submit, .sticky-atc__add_button');
    if (!btn || !rootEl()) return;
    if (pending) {                      /* a second tap while the first is being handled */
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (!cart.stale.length) { setTimeout(readCart, 4000); return; }
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    e.preventDefault();
    e.stopImmediatePropagation();
    pending = true;
    btn.classList.add('loading');

    var updates = {};
    for (var i = 0; i < cart.stale.length; i++) updates[cart.stale[i]] = 0;
    cart.stale = [];

    var done = false;
    var timer = null;
    function press() {
      if (done) return;
      done = true;
      if (timer) clearTimeout(timer);
      btn.classList.remove('loading');
      pending = false;
      passing = true;
      try { btn.click(); } catch (err) { /* nothing more to do */ }
      passing = false;
      setTimeout(readCart, 4000);
    }
    timer = setTimeout(press, 2500);
    try {
      window.fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(press, press);
    } catch (err) {
      press();
    }
  }
  document.addEventListener('click', onePack, true);

  /* ---- page behaviour --------------------------------------------------------- */

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  function scrollToEl(target, offset) {
    if (!target) return false;
    var y = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset;
    try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, Math.max(0, y)); }
    return true;
  }

  /* Smooth scroll to the bundle rows. Neither button that calls this adds to cart. */
  function toOffer(offset) {
    return scrollToEl(document.querySelector('[data-cl3-offer]') || document.querySelector('.c2-bundle-h') || rootEl(), offset);
  }

  /* Tabs: one of three panels. */
  function onTab(btn) {
    var wrap = btn.closest('[data-c2-tabs]');
    if (!wrap) return;
    var n = btn.getAttribute('data-c2-tab');
    each(wrap.querySelectorAll('[data-c2-tab]'), function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    each(wrap.querySelectorAll('[data-c2-panel]'), function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-c2-panel') === n);
    });
  }

  /* Accordions: opening one closes the one that was open. */
  function onAcc(btn) {
    var item = btn.closest('.c2-acc__item');
    var list = btn.closest('[data-c2-acc]');
    if (!item || !list) return;
    var open = !item.classList.contains('is-open');
    each(list.querySelectorAll('.c2-acc__item'), function (it) {
      it.classList.remove('is-open');
      var b = it.querySelector('.c2-acc__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (open) {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  /* Full formula modal: one node, moved to the body so its backdrop covers the page. */
  var modalFrom = null;

  function modalEl() {
    return document.querySelector('[data-c2-modal]');
  }

  function openModal(from) {
    var m = modalEl();
    if (!m) return;
    if (m.parentNode !== document.body) document.body.appendChild(m);
    modalFrom = from || null;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('c2-lock');
    var x = m.querySelector('[data-c2-modal-close]');
    if (x && x.focus) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
  }

  function closeModal() {
    var m = modalEl();
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('c2-lock');
    if (modalFrom && modalFrom.focus) { try { modalFrom.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
    modalFrom = null;
  }

  /* Questions: three tabs, six shown at a time, several answers may be open. */
  function qaShow(wrap, cat, limit) {
    var step = parseInt(wrap.getAttribute('data-c2-qa-step'), 10) || 6;
    var cards = wrap.querySelectorAll('[data-c2-qa-cat]');
    var n = 0;
    var total = 0;
    each(cards, function (c) {
      var mine = c.getAttribute('data-c2-qa-cat') === cat;
      if (mine) total++;
      var show = mine && n < limit;
      if (mine && show) n++;
      c.hidden = !show;
    });
    wrap.setAttribute('data-c2-qa-shown', String(Math.max(limit, step)));
    var more = wrap.querySelector('[data-c2-qa-more]');
    if (more) more.hidden = !(total > limit);
  }

  function onQaTab(btn) {
    var wrap = btn.closest('[data-c2-qa]');
    if (!wrap) return;
    var step = parseInt(wrap.getAttribute('data-c2-qa-step'), 10) || 6;
    each(wrap.querySelectorAll('[data-c2-qa-tab]'), function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    each(wrap.querySelectorAll('.c2-qa__card'), function (c) {
      c.classList.remove('is-open');
      var q = c.querySelector('.c2-qa__q');
      if (q) q.setAttribute('aria-expanded', 'false');
    });
    qaShow(wrap, btn.getAttribute('data-c2-qa-tab'), step);
  }

  function onQaMore(btn) {
    var wrap = btn.closest('[data-c2-qa]');
    if (!wrap) return;
    var step = parseInt(wrap.getAttribute('data-c2-qa-step'), 10) || 6;
    var shown = parseInt(wrap.getAttribute('data-c2-qa-shown'), 10) || step;
    var active = wrap.querySelector('[data-c2-qa-tab].is-active');
    qaShow(wrap, active ? active.getAttribute('data-c2-qa-tab') : 'product', shown + step);
  }

  function onQaQuestion(btn) {
    var card = btn.closest('.c2-qa__card');
    if (!card) return;
    var open = card.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* Gallery: this template's own. The track scrolls sideways with snap; a thumbnail
     jumps to its slide and the thumbnail of the slide on screen is marked. */
  function galInit() {
    each(document.querySelectorAll('[data-c2-gal]'), function (g) {
      if (g.__c2gal) return;
      var track = g.querySelector('[data-c2-gal-track]');
      var strip = g.querySelector('[data-c2-gal-thumbs]');
      var thumbs = g.querySelectorAll('[data-c2-gal-thumb]');
      if (!track || !thumbs.length) return;
      g.__c2gal = true;
      var current = 0;
      function mark(i) {
        if (i < 0 || i >= thumbs.length) return;
        current = i;
        each(thumbs, function (t, k) {
          t.classList.toggle('is-active', k === i);
          if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (strip) {
          var t = thumbs[i];
          var left = t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
          try { strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); } catch (e) { strip.scrollLeft = Math.max(0, left); }
        }
      }
      var busy = false;
      track.addEventListener('scroll', function () {
        if (busy) return;
        busy = true;
        (window.requestAnimationFrame || window.setTimeout)(function () {
          busy = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) mark(i);
        });
      }, { passive: true });
      each(thumbs, function (t, i) {
        t.addEventListener('click', function () {
          var x = i * track.clientWidth;
          try { track.scrollTo({ left: x, behavior: 'smooth' }); } catch (e) { track.scrollLeft = x; }
          mark(i);
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var hit;
    if ((hit = t.closest('[data-c2-tab]'))) { onTab(hit); return; }
    if ((hit = t.closest('.c2-acc__btn'))) { onAcc(hit); return; }
    if ((hit = t.closest('[data-c2-formula-open]'))) { e.preventDefault(); openModal(hit); return; }
    if (t.closest('[data-c2-modal-close]')) { closeModal(); return; }
    if ((hit = t.closest('[data-c2-modal]')) && !t.closest('[data-c2-modal-panel]')) { closeModal(); return; }
    if ((hit = t.closest('[data-c2-qa-tab]'))) { onQaTab(hit); return; }
    if ((hit = t.closest('[data-c2-qa-more]'))) { onQaMore(hit); return; }
    if ((hit = t.closest('.c2-qa__q'))) { onQaQuestion(hit); return; }
    if ((hit = t.closest('[data-c2-to-offer]'))) {
      e.preventDefault();
      toOffer(parseInt(hit.getAttribute('data-c2-to-offer'), 10) || 120);
      return;
    }
    if ((hit = t.closest('[data-c2-to-reviews], .c2 a[href="#c2-reviews"]'))) {
      if (scrollToEl(document.getElementById('c2-reviews'), 90)) e.preventDefault();
    }
  }, false);

  /* The sticky bar is the theme's own block in scroll mode. Its target is the top
     of the buy column; this page sends it to the bundle rows instead. If this
     listener never runs, the theme's own scroll still works. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.sticky-atc__scroll-btn')) return;
    if (!toOffer(160)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeModal();
  }, false);

  function shipWhen() {
    var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var d = new Date();
    d.setDate(d.getDate() + 1);
    var label = M[d.getMonth()] + ' ' + d.getDate();
    each(document.querySelectorAll('[data-c2-ship-when]'), function (n) {
      if (n.textContent !== label) n.textContent = label;
    });
  }

  function pageFixes() {
    if (!rootEl() && !document.querySelector('[data-cl3-offer]')) return;
    safely(galInit);
    safely(shipWhen);
  }

  document.addEventListener('shopify:section:load', function () { cache.list = null; schedule(); pageFixes(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) safely(shipWhen); });

  function start() {
    schedule();
    pageFixes();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', start);
  window.addEventListener('pageshow', function () { schedule(); readCart(); });

  window.furbosCleanse3 = { render: render, state: state, cart: cart };
})();
